var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "88", viewBox: "0 0 32 88", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-0a)" },
      React.createElement("path", { d: "M8 1H12C14.2091 1 16 2.79086 16 5V29M8 87H12C14.2091 87 16 85.2091 16 83V59", stroke: "#9B9B9B", strokeLinecap: "round" }),
      React.createElement("circle", { cx: "16", cy: "44", r: "15.5", fill: "#fff", stroke: "#9B9B9B" }),
      React.createElement("path", { d: "M10 51V40C10 38.3431 11.3431 37 13 37V37C14.6569 37 16 38.3431 16 40V48C16 49.6569 17.3431 51 19 51V51C20.6569 51 22 49.6569 22 48V37M10 51L12 49M10 51L8 49M22 37L20 39M22 37L24 39", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-0a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H32V88H0z" })
      )
    )
  );
});